"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportLocalStorage = void 0;
/* global window */
var supportLocalStorage = exports.supportLocalStorage = function supportLocalStorage() {
  try {
    return typeof window !== 'undefined' && window.localStorage;
  } catch (error) {
    return false;
  }
};